// extracted by mini-css-extract-plugin
export default {"container":"DropdownItem_container__PE73D","text":"DropdownItem_text__hnSTn"};